import type { FormExtractorResponse, FormGeneratorResponse, FeasibilityResponse, FeasibilitySummarisationSubmitResponse, FeasibilitySummarisationResponse } from '@/types/material/formulation';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

@injectable()
export class MaterialFormulationApiImpl extends PsHttpService implements MaterialFormulationApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/material/formulation`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getExtractedData(agent_job_id: string, doc_id: string) {
        return this.get<PatSnapCommonResponseData<FormExtractorResponse>>({
            url: '/get-extracted-data',
            params: {
                agent_job_id,
                doc_id,
            },
        }).then(res => {
            return res.data as FormExtractorResponse
        })
    }

    getGeneratedData(agent_job_id: string, set_version: string) {
        return this.get<PatSnapCommonResponseData<Record<string, any>>>({
            url: '/get-generated-data',
            params: {
                agent_job_id,
                set_version,
            },
        }).then(res => {
            return res.data as FormGeneratorResponse
        })
    }

    pushToFeasibility(flow_id: string, formulation_list: string[]): Promise<string> {
        return this.post<PatSnapCommonResponseData<string>>({
            url: '/push-to-feasibility',
            data: {
                flow_id,
                formulation_list,
            },
        }).then((res) => {
            return res.data as string
        });
    }

    getFeasibilityAnalysis(agent_job_id: string) {
        return this.get<PatSnapCommonResponseData<FeasibilityResponse>>({
            url: '/get-feasibility-analysis',
            params: {
                agent_job_id,
            },
        }).then(res => {
            return res.data as FeasibilityResponse
        })
    }

    submitSummarisation(agent_job_id: string, formulation_name: string): Promise<FeasibilitySummarisationSubmitResponse> {
        return this.post<PatSnapCommonResponseData<FeasibilitySummarisationSubmitResponse>>({
            url: '/submit-single-summarisation',
            data: {
                agent_job_id,
                formulation_name,
            },
        }).then((res) => {
            return res.data as FeasibilitySummarisationSubmitResponse
        });
    }

    getSingleSummarisation(agent_job_id: string, formulation_name: string) {
        return this.get<PatSnapCommonResponseData<FeasibilitySummarisationResponse>>({
            url: '/get-single-summarisation',
            params: {
                agent_job_id,
                formulation_name,
            },
        }).then(res => {
            return res.data as FeasibilitySummarisationResponse
        })
    }
}

export const MaterialFormulationApi = Symbol('MaterialFormulationApi');

export interface MaterialFormulationApi {
    getExtractedData(agent_job_id: string, doc_id: string): Promise<FormExtractorResponse>;
    getGeneratedData(agent_job_id: string, set_version: string): Promise<FormGeneratorResponse>;
    pushToFeasibility(flow_id: string, formulation_list: string[]): Promise<string>;
    getFeasibilityAnalysis(agent_job_id: string): Promise<FeasibilityResponse>;
    submitSummarisation(agent_job_id: string, formulation_name: string): Promise<FeasibilitySummarisationSubmitResponse>;
    getSingleSummarisation(agent_job_id: string, formulation_name: string): Promise<FeasibilitySummarisationResponse>;
}
